<div class="field text-left mt-3">
    <div class="flex justify-content-between">
        <div>

            <p-button label="Save" icon="pi pi-save" size="small" (click)="saveComment()" [disabled]="Edit" ></p-button>

        </div>
    </div>
</div>

<div class="card">
    <div class="grid">
        <div class="col">
            <div class="field text-left">
                <label>Remark</label>
                <textarea id="comments" pInputTextarea  [(ngModel)]="comment" class="w-full mt-2"></textarea>
            </div>

        </div>
    </div>
</div>
